import React from 'react';
import { Stack, Text, FontWeights, PrimaryButton, DefaultButton } from 'office-ui-fabric-react';
import { connect } from 'react-redux';
import { goBack, replace } from 'connected-react-router';
import { CREATE_MEETING_COMMAND } from './meeting-creator/actions';
import { Header } from './components/header';
import errorImage from './images/genericError.svg';
import { FormattedMessage } from 'react-intl';
import { translate } from './localization/translate';
const boldStyle = { root: { fontWeight: FontWeights.semibold } };
const mapStateToProps = (state) => ({
    meeting: state.meeting.inputMeeting
});
const mapDispatchToProps = (dispatch) => ({
    goBack: () => dispatch(goBack()),
    retryCreateMeeting: (meeting) => {
        dispatch(replace('/createMeeting'));
        dispatch({
            type: CREATE_MEETING_COMMAND,
            meeting
        });
    }
});
function ErrorPageComponent(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        React.createElement(Stack, { className: "container", horizontalAlign: "center", verticalAlign: "center", verticalFill: true, tokens: {
                childrenGap: 35
            } },
            React.createElement("img", { className: "splashImage", src: errorImage, alt: translate('errorPage.splash.altText') }),
            React.createElement(Text, { variant: "xLargePlus", styles: boldStyle },
                React.createElement(FormattedMessage, { id: "errorPage.heading" })),
            React.createElement(Text, { variant: "medium", className: "uTextCenter" },
                React.createElement(FormattedMessage, { id: "errorPage.subheading" })),
            React.createElement(Stack, { horizontal: true, tokens: { childrenGap: 10 } },
                React.createElement(DefaultButton, { className: "teamsButtonInverted", onClick: () => props.goBack(), ariaLabel: translate('errorPage.back.ariaLabel') },
                    React.createElement(FormattedMessage, { id: "errorPage.back" })),
                React.createElement(PrimaryButton, { className: "teamsButton", onClick: () => props.retryCreateMeeting(props.meeting), ariaLabel: translate('errorPage.try.again') },
                    React.createElement(FormattedMessage, { id: "errorPage.try.again" }))))));
}
export default connect(mapStateToProps, mapDispatchToProps)(ErrorPageComponent);
